import React, {Component} from 'react';

// Import custom components
import Title from './title.component';

class Transaction extends Component {

    render() {
        return (
            <div>
                <Title />

                <section>

                    {this.props.children}

                </section>

            </div>
        );
    }
}

export default Transaction;
